import React from "react";
import SubmitButton from "../../submitButton/SubmitButton";

function SalesQueryThankYou({
  thankYouHeader,
  responseMessage,
  trackingInfo,
  onReset,
}) {
  return (
    <div className="text-center">
      <i className="fas fa-check-circle text_master2 fa-3x mb-3"></i>
      {thankYouHeader && <h2>{thankYouHeader}</h2>}
      <p className="lead">{responseMessage}</p>
      <p className="mt-3 line_height1_7">
        {trackingInfo.description}
        <br />
        <strong>{trackingInfo.trackingId}</strong>
      </p>
      <div className="d-flex justify-content-center">
        <SubmitButton
          onClick={onReset}
          className="mt-2 rounded-pill"
          label=" Submit Another Query"
        />
      </div>
    </div>
  );
}

export default SalesQueryThankYou;
